import api from "@/config/axios";

const URL_CONTENIDO = "web/content/";

export default {
  obtenerInformativos() {
    return api.get(URL_CONTENIDO + `getInformativesPortal`);
  },
  obtenerPublicidades(params, dialogo) {
    let visibilidad = 0; //Silder
    if (dialogo) visibilidad = 1; //Dialogo
    return api.get(
      URL_CONTENIDO +
        `getAdvertisingPortal/${visibilidad}/${params.tipo}/${params.capital}/${params.creditos}/${params.dap}/${params.libretas}`
    );
  },
  obtenerCategorias(tipo) {
    return api.get(URL_CONTENIDO + `getFilesCategories/${tipo}`);
  },
  obtenerDocumentos(categoria) {
    return api.get(
      URL_CONTENIDO +
        `getFileRefsByIdNameByCategory/revistas_portal/${categoria}`
    );
  },
  obtenerModoRevista(id) {
    return api.get(URL_CONTENIDO + `getFileToViewer/${id}`);
  },
  obtenerDataArchivo(id) {
    return api.get(URL_CONTENIDO + `getFileData/${id}`);
  },
  obtenerSecciones() {
    return api.get(URL_CONTENIDO + `getSectionsByType/portal`);
  },
  obtenerTextoByIdName(id_name) {
    return api.get(URL_CONTENIDO + `getTextByIdName/${id_name}`);
  },
  obtenerTextoByGroup(group) {
    return api.get(URL_CONTENIDO + `getTextByGroup/${group}`);
  },
  obtenerParametros() {
    return api.get(URL_CONTENIDO + `getParamsPortal`);
  },
  obtenerParametrosPorTipo(tipo) {
    return api.get(URL_CONTENIDO + `getParamsByType/${tipo}`);
  },
  obtenerOficinas() {
    return api.get(URL_CONTENIDO + `getOffices/`);
  }
};
